import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { Metrics } from '@zocdoc/frontend-metrics';

import AppointmentInfoStateManager from '../AppointmentInfo/AppointmentInfoStateManager';
import ReviewAndBookPageStateManager from './ReviewAndBookPageStateManager';
import ReviewAndBookPageView from './ReviewAndBookPageView';
import mapDispatchToProps from './mapDispatchToProps';
import mapStateToProps from './mapStateToProps';
import mergeProps from './mergeProps';
import SelectPatientStateManager from '../SelectPatient/SelectPatientStateManager';
import withProviderProcedures from '../AppointmentInfo/withProviderProcedures';
import LoadingOverlay from '../../components/LoadingOverlay';
import withInsuranceValidation from './withInsuranceValidation';

/**
 * TODO: There's no reason for this page to exist besides currently having to smush all
 * state managers together around the ReviewAndBookPageView. Once all state management is
 * consolidated within ReviewAndBookPageStateManager, this can also be absorbed
 * by ReviewAndBookStateManager, and we can remove this container.
 */
export class ReviewAndBookPageContainer extends Component {
    async componentDidMount() {
        const { params, surveyQuestionsData } = this.props;
        this.props.fetchInitialBookingData(params.bookingId);
        if (!surveyQuestionsData || isEqual(surveyQuestionsData, {})) {
            // if the server side fetch questions fails, try again client side
            this.props.fetchSurveyData(params.bookingId);
        }
    }

    render() {
        const { bookingState } = this.props;
        if (bookingState === undefined) {
            return (
                <React.Fragment>
                    <div style={{ display: 'none' }}>
                        {this.renderPageContent()}
                    </div>
                    <LoadingOverlay />
                </React.Fragment>
            );
        } else {
            return this.renderPageContent();
        }
    }

    renderPageContent() {
        const {
            professional,
            insuranceIsAccepted,
            insuranceIsValidating,
            shouldShowInsuranceAdvocacy,
            shouldShowMentalHealthOONBenefits,
            showVaccineDisclaimer,
            trackClickAddPhone,
            trackClickContinue,
            trackClickEditPhone,
            surveyQuestionsData,
            ...stateManagerProps
        } = this.props;

        return (
            <Metrics category="Booking - Appt Info" page="Booking - Appt Info">
                <AppointmentInfoStateManager
                    {...stateManagerProps}
                    trackClickContinue={trackClickContinue}
                >
                    <SelectPatientStateManager>
                        <ReviewAndBookPageStateManager>
                            <ReviewAndBookPageView
                                insuranceIsAccepted={insuranceIsAccepted}
                                insuranceIsValidating={insuranceIsValidating}
                                professional={professional}
                                trackClickAddPhone={trackClickAddPhone}
                                trackClickEditPhone={trackClickEditPhone}
                                trackNewSubpatientClickContinue={
                                    trackClickContinue
                                }
                                shouldShowInsuranceAdvocacy={
                                    shouldShowInsuranceAdvocacy
                                }
                                shouldShowMentalHealthOONBenefits={
                                    shouldShowMentalHealthOONBenefits
                                }
                                bookingId={this.props.params.bookingId}
                                showVaccineDisclaimer={showVaccineDisclaimer}
                                surveyQuestionsData={surveyQuestionsData}
                            />
                        </ReviewAndBookPageStateManager>
                    </SelectPatientStateManager>
                </AppointmentInfoStateManager>
            </Metrics>
        );
    }
}
const ReviewAndBookPageContainerWithData = withInsuranceValidation(
    withProviderProcedures(ReviewAndBookPageContainer)
);

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(hot(module)(ReviewAndBookPageContainerWithData));
